module.exports = __webpack_public_path__ + "img/icon-gavel.af6f67b8.svg";